<template>
  <div>
    <v-list
      two-line>
      <v-container>
        <v-list-item>
          <v-col md="3">
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-list-item-avatar
                  v-on="on"
                  @click="pickImage"
                  :size="80">
                  <img
                    :src="teacher.iconUrl"
                    alt="">
                </v-list-item-avatar>
              </template>
              <span>クリックして新しい画像を選択</span>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/*"
                @change="onFilePicked"
              >
            </v-tooltip>
            <v-card-text
              class="font-weight-bold red--text"
              v-show="errorMessage">
              {{ errorMessage }}
            </v-card-text>
          </v-col>

          <v-col>
            <v-container>
              <v-row>
                <v-col>
                    <h1>{{ teacher.fullName() }}</h1>
                  <v-list>
                    <v-list-item-subtitle >
                      {{ teacher.genderInJapanese()}}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ teacher.universityInfo() }}
                    </v-list-item-subtitle>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-list-item>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-space-around>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">住所</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              {{ teacher.fullAddress() }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">生年月日</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              {{ teacher.birthdayToString() }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">電話番号</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              {{ teacher.phone }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">指導可能日時</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              <v-chip
                class="ma-1"
                v-for="schedule in teacher.availableSchedulesToStrings()"
                :key="schedule"
                outlined
              >
                {{ schedule }}
              </v-chip>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">最寄り駅</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              {{ teacher.nearestStation }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">希望報酬単価</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text>
              {{ teacher.expectedWage }}円
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <v-container pl-10>
        <v-row align-center>
          <v-col md="3">
            <v-card-text>
              <span class="grey--text">自己紹介</span>
            </v-card-text>
          </v-col>
          <v-col md="9">
            <v-card-text class="line--feed">
              {{ teacher. selfIntroduction }}
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

    </v-list>
    <v-dialog
      v-model="dialog"
      :max-width="500"
      :max-height="500"
      hide-overlay
      :disabled="!imgSrc"
    >
      <template v-slot:activator="{ on }">
        <img
          v-on="on"
          v-show="cropSrc"
          slot="activator"
          :src="cropSrc"
          style="width: 200px; border: 1px solid gray"
          alt="Cropped Image"
        />
      </template>
      <v-card>
        <v-card-text>
          <vue-cropper
            ref="cropper"
            :guides="false"
            :view-mode="0"
            drag-mode="move"
            :auto-crop-area="0.5"
            :min-container-width="400"
            :min-container-height="400"
            :background="true"
            :aspectRatio="1/1"
            :src="imgSrc"
            alt="Source Image"
            :modal="true"
            :img-style="{ width: '400px', height: '400px' }"
            :center="false"
            :highlight="true"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="save"
            text
            color="primary">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import VueCropper from 'vue-cropperjs'
import { app } from '@/core/firebase.js'
import { TeacherRepository } from '@/repository/TeacherRepository.js'
import { firestore } from '@/repository/client/firestore.js'

export default {
  name: 'TeacherProfileDisplay',
  components: {
    'VueCropper': VueCropper
  },
  data() {
    return {
      imgSrc: '',
      cropSrc: '',
      dialog: false,
      repo: null,
      errorMessage: ''
    }
  },
  props: {
    teacher: {
      required: true,
      type: Object
    }
  },
  created: function() {
    this.repo = new TeacherRepository(firestore)
  },
  methods: {
    pickImage() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      if (e.target.files.length === 1) {
        this.selectedFile = e.target.files[0]
        const self = this
        const reader = new FileReader()
        reader.readAsDataURL(self.selectedFile)
        // reader.onerror = e => {
        //   console.log(e)
        // }
        reader.onload = () => {
          self.imgSrc = reader.result
          // this.$refs.cropper.replace(self.imgSrc)
          self.dialog = true
        }
      } else {
        this.errorMessage = "再度選択してください"
      }

    },
    save() {
      const self = this
      const path = `images/icon/${this.teacher.uuid}.jpg`
      const croppedImg = this.$refs.cropper
        .getCroppedCanvas({
          maxWidth: 400,
          maxHeight: 400
        })
        .toBlob(
          async blob => {
            const storage = app.storage().ref(path)
            const snapshot = await storage.put(blob)
            const url = await app.storage().ref(path).getDownloadURL()
            self.teacher.iconUrl = url
            await self.repo.update(self.teacher)
            self.dialog = false
          },
          "image/jpeg",
          0.95
        )
    }
  }
}
</script>

